import { de, enUS } from 'date-fns/locale';

export default { enUS, de };
